module.exports = __webpack_public_path__ + "img/img01.f14ed66a.svg";